/** Plan limits and upgrade notices. */
export default {
  upgrade: "Upgrade",
  knowledgeGraphTitle: "Knowledge graph is available on Pro",
  knowledgeGraphDescription:
    "Upgrade to remember useful context across conversations.",
  onscreenUsedUpTitle: "On-screen requests used up",
  onscreenUsedUpDescription:
    "You’ve used this month’s {count} Free on-screen requests. Denker answers in words until {date}.",
  appLimitReached: "App limit reached",
} as const;
